import { render, staticRenderFns } from "./AllStore.vue?vue&type=template&id=31975488"
import script from "./AllStore.vue?vue&type=script&lang=js"
export * from "./AllStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports